import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormlyFieldDatepicker } from '@ngx-formly/material/datepicker';
import { add, sub, toDate } from 'date-fns';
import { replace, split, startsWith } from 'lodash';

@Component({
    selector: 'lockton-apps-yearpicker-type',
    templateUrl: './yearpicker-type.component.html',
    styleUrls: ['./yearpicker-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class YearpickerTypeComponent extends FormlyFieldDatepicker {
  min: any;
  max: any;

  ngOnInit(): void {
    this.setMinMaxDate(
      this.props.datepickerOptions?.min,
      this.props.datepickerOptions?.max
    );
  }

  private setMinMaxDate(min: any, max: any): void {
    this.min = this.buildDate(min);
    this.max = this.buildDate(max);
  }

  private buildDate(date: any): Date {
    if (!startsWith(date, 'calc=')) {
      return date;
    }

    const [startDate, action, duration]: string[] = split(
      replace(date, 'calc=', ''),
      '|'
    );

    switch (action) {
      case 'add':
        return add(this.getStartDate(startDate), JSON.parse(duration));

      case 'sub':
        return sub(this.getStartDate(startDate), JSON.parse(duration));

      default:
        return this.getStartDate(startDate);
    }
  }

  private getStartDate(value: any): Date {
    return value === 'now' ? new Date() : toDate(value);
  }
}
